var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileHeadset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.297,
    height: 31.833,
    viewBox: "0 0 36.297 31.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_13786",
    x: 0,
    y: 0,
    width: 36.297,
    height: 31.833,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Audio_3408360",
    transform: "translate(6.5 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15648",
    "data-name": "Group 15648",
    transform: "translate(2.5 14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_13786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13786-2",
    "data-name": "Path 13786",
    d: "M18.3,21.657v-.981a6.657,6.657,0,1,0-13.314,0v.981a2.728,2.728,0,0,0,.25,5.445h.25v.1a.641.641,0,0,0,.635.635h.5a.641.641,0,0,0,.635-.635V21.542a.641.641,0,0,0-.635-.635H6.386v-.231a5.252,5.252,0,0,1,10.5,0v.231H16.66a.641.641,0,0,0-.635.635V27.2a.641.641,0,0,0,.635.635h.5A.641.641,0,0,0,17.8,27.2v-.1h.269A2.73,2.73,0,0,0,20.8,24.37,2.769,2.769,0,0,0,18.3,21.657Z",
    transform: "translate(6.5 -8)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHeadset);
export default __webpack_public_path__ + "static/media/file-headset.543c747856983a707881bacf85d2098e.svg";
export { ForwardRef as ReactComponent };